module.exports = __webpack_public_path__ + "img/logo.a3c62a3c.png";